import ViewWorkSection from '@Components/ViewWork/ViewWorkSection'
import WriterCard from '@Components/ViewWork/WriterCard'
import React from 'react'
import { ZodFormattedError } from 'zod'
import Navigation from '@App/navigation'
import { WorkType } from '@Components/ViewWork/work-type'
import EditButton from '@Components/ViewWork/EditButton'
import { WriterModel } from '@Entities/work/writer-model'

interface WritersSectionProps {
    writers: WriterModel[]
    workId: number
    rightsholderId?: number
    workType?: WorkType
    editing?: boolean
    writerErrors?: ZodFormattedError<WriterModel[]>
}

const WritersSection = (props: WritersSectionProps) => {
    const generateWritersEditLink = () => {
        if (!props.rightsholderId) {
            return Navigation.home.root()
        }
        switch (props.workType) {
            case 'bulk':
                return Navigation.rightholder.createWork.bulk.edit.writers(props.rightsholderId)
            case 'create-form':
                return Navigation.rightholder.createWork.form.writers(props.rightsholderId)
            case 'create-wizard':
                return Navigation.rightholder.createWork.wizard.writers(props.rightsholderId)
            case 'draft':
                return Navigation.rightholder.registrationDrafts.writers(
                    props.rightsholderId,
                    props.workType,
                    props.workId
                )
            default:
                if (!props.workType) {
                    return Navigation.home.root()
                } else {
                    return Navigation.rightholder.catalog.workEdit.writers(
                        props.rightsholderId,
                        props.workType,
                        props.workId
                    )
                }
        }
    }

    const writersEditLink = generateWritersEditLink()

    return (
        <ViewWorkSection
            valid={props.editing !== undefined ? !props.writerErrors : undefined}
            icon="writers"
            title="Writers"
            count={props.writers.length}
            rightData={
                <>
                    {props.editing && (
                        <EditButton linkTo={writersEditLink} workType={props.workType} wizardFlowIndex={2} />
                    )}
                </>
            }
        >
            <WriterCard writers={props.writers} errors={props.writerErrors} />
        </ViewWorkSection>
    )
}

export default WritersSection
